import React from "react";
import { Link } from "react-router-dom";

import { LEGAL_CONFIG } from "./legal-config";
import { LegalPage, LegalSection } from "./legal-page";

const CookiePolicy: React.FC = () => {
  return (
    <LegalPage
      title="Pliki cookie i pamięć przeglądarki"
      lead="Serwis nie śledzi użytkowników. Poniżej pełna lista tego, co zapisujemy w Twojej przeglądarce i dlaczego."
    >
      <LegalSection id="krotko" number="1" title="Krótko">
        <ul>
          <li>
            <strong>Nie używamy plików cookie</strong> do logowania ani do żadnej innej
            funkcji serwisu.
          </li>
          <li>
            <strong>Nie korzystamy z analityki</strong> (Google Analytics, Matomo,
            Hotjar itp.), reklam, pikseli społecznościowych ani narzędzi profilujących.
          </li>
          <li>
            Zapisujemy w pamięci lokalnej przeglądarki (localStorage) wyłącznie dane
            niezbędne do utrzymania Twojego zalogowania oraz wybrany przez Ciebie
            wygląd strony wyników.
          </li>
          <li>
            Dlatego nie wyświetlamy baneru zgody — zgoda na przechowywanie niezbędne do
            świadczenia usługi, o którą sam poprosiłeś, nie jest wymagana (art. 399 ust. 3
            ustawy Prawo komunikacji elektronicznej).
          </li>
        </ul>
      </LegalSection>

      <LegalSection id="lista" number="2" title="Co dokładnie zapisujemy">
        <p>
          Serwis publiczny ({LEGAL_CONFIG.serviceDomains.join(" i ")}) — dane zapisywane
          dopiero po zalogowaniu:
        </p>
        <table className="legal-table">
          <thead>
            <tr>
              <th>Klucz</th>
              <th>Rodzaj</th>
              <th>Do czego służy</th>
              <th>Jak długo</th>
              <th>Zgoda</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-label="Klucz">
                <code>auth_token</code>
              </td>
              <td data-label="Rodzaj">localStorage</td>
              <td data-label="Do czego służy">
                token sesji — utrzymuje zalogowanie między odsłonami stron, bez niego
                każde kliknięcie wymagałoby ponownego podania hasła
              </td>
              <td data-label="Jak długo">do wylogowania, token traci ważność po 7 dniach</td>
              <td data-label="Zgoda">niewymagana (niezbędny)</td>
            </tr>
          </tbody>
        </table>

        <p>Panel organizatora — dostępny wyłącznie dla kont klubowych:</p>
        <table className="legal-table">
          <thead>
            <tr>
              <th>Klucz</th>
              <th>Rodzaj</th>
              <th>Do czego służy</th>
              <th>Jak długo</th>
              <th>Zgoda</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-label="Klucz">
                <code>admin_token</code>
              </td>
              <td data-label="Rodzaj">localStorage</td>
              <td data-label="Do czego służy">token sesji organizatora</td>
              <td data-label="Jak długo">do wylogowania, token traci ważność po 7 dniach</td>
              <td data-label="Zgoda">niewymagana (niezbędny)</td>
            </tr>
            <tr>
              <td data-label="Klucz">
                <code>admin_role</code>, <code>admin_id</code>,{" "}
                <code>admin_username</code>, <code>admin_club_id</code>,{" "}
                <code>admin_club_name</code>
              </td>
              <td data-label="Rodzaj">localStorage</td>
              <td data-label="Do czego służy">
                zapamiętanie roli, konta i klubu, żeby panel pokazał właściwe menu bez
                dodatkowego zapytania do serwera
              </td>
              <td data-label="Jak długo">do wylogowania</td>
              <td data-label="Zgoda">niewymagana (niezbędny)</td>
            </tr>
          </tbody>
        </table>
        <p>Strona wpisywania wyników kolejki — zapisywane dopiero po kliknięciu przełącznika:</p>
        <table className="legal-table">
          <thead>
            <tr>
              <th>Klucz</th>
              <th>Rodzaj</th>
              <th>Do czego służy</th>
              <th>Jak długo</th>
              <th>Zgoda</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-label="Klucz">
                <code>scoring_view</code>
              </td>
              <td data-label="Rodzaj">localStorage</td>
              <td data-label="Do czego służy">
                zapamiętanie wybranego widoku (pełny albo duży), żeby nie przełączać go
                przy każdym wejściu
              </td>
              <td data-label="Jak długo">do wyczyszczenia danych witryny</td>
              <td data-label="Zgoda">niewymagana (ustawienie, o które prosisz)</td>
            </tr>
          </tbody>
        </table>
        <p>
          Żaden z tych kluczy nie służy do śledzenia, budowania profilu ani łączenia
          Twojej aktywności między różnymi serwisami.
        </p>
      </LegalSection>

      <LegalSection id="zewnetrzne" number="3" title="Zasoby zewnętrzne">
        <p>
          Nie ma żadnych. Wszystko, czego strona potrzebuje do działania — łącznie
          z krojami pism — pobierane jest z naszego serwera. Twoja przeglądarka nie łączy
          się z Google, Facebookiem ani z żadnym innym podmiotem, więc Twój adres IP nie
          trafia nigdzie poza serwer tego serwisu i jego dostawcę hostingu, wymienionego
          w <Link to="/prywatnosc">polityce prywatności</Link>.
        </p>
        <p>
          Nie osadzamy map, filmów, przycisków społecznościowych ani skryptów
          reklamowych.
        </p>
      </LegalSection>

      <LegalSection id="kontrola" number="4" title="Jak to usunąć albo zablokować">
        <ul>
          <li>
            <strong>Wylogowanie</strong> w serwisie kasuje token sesji i pozostałe klucze
            — to najprostszy sposób.
          </li>
          <li>
            <strong>Ustawienia przeglądarki</strong> — w sekcji prywatności każdej
            przeglądarki znajdziesz opcję „wyczyść dane witryny” lub „usuń pliki cookie
            i dane witryn”. Usuwa ona również pamięć lokalną tej strony.
          </li>
          <li>
            <strong>Blokada pamięci lokalnej</strong> dla tej domeny jest możliwa, ale
            uniemożliwi zalogowanie się. Przeglądanie rankingów i wyników będzie działać
            normalnie — strona wyników po prostu nie zapamięta wybranego widoku.
          </li>
        </ul>
      </LegalSection>

      <LegalSection id="podstawa" number="5" title="Podstawa prawna">
        <p>
          Przechowywanie informacji w urządzeniu końcowym reguluje art. 399 ustawy z dnia
          12 lipca 2024 r. — Prawo komunikacji elektronicznej, który zastąpił art. 173
          dawnego Prawa telekomunikacyjnego. Co do zasady wymaga on uprzedniej zgody
          użytkownika, a art. 399 ust. 3 zwalnia z niej przechowywanie niezbędne do
          świadczenia usługi drogą elektroniczną żądanej przez użytkownika. Utrzymanie
          zalogowanej sesji jest właśnie takim przypadkiem. Gdyby serwis zaczął używać
          analityki lub innych mechanizmów nieniezbędnych, poprosimy o zgodę zanim
          cokolwiek zapiszemy.
        </p>
        <p>
          Pytania dotyczące tej informacji: <strong>{LEGAL_CONFIG.contactEmail}</strong>.
        </p>
      </LegalSection>
    </LegalPage>
  );
};

export default CookiePolicy;
